import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

class CSVUploadModal extends React.Component {
  initialState = {
    isLoading: false,
    showModal: false,
    selectedFile: null,
    result: null,
    error: null,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleShow = () => {
    this.setState({ showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  fileChange = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      result: null,
      error: null,
    });
  };

  fileUpload = () => {

    if(this.state.selectedFile.type !== 'text/csv') {
      this.setState({ error: 'Please upload a valid csv file' });
      return
    }

    if(this.state.selectedFile.size === 0) {
      this.setState({ error: 'The uploaded CSV file is empty' });
      return
    }

    this.setState({ isLoading: true });

    // Read only the first 1KB of the file to verify it's not empty without loading the entire file into memory
    const slice = this.state.selectedFile.slice(0, 1024);
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result.trim();
      if (content.length === 0) {
        this.setState({ error: 'The uploaded CSV file is empty', isLoading: false });
        return;
      }
      this.performUpload();
    };
    reader.onerror = () => {
      this.setState({ error: 'Failed to read the file', isLoading: false });
    };
    reader.readAsText(slice);
    };

  performUpload = () => {
    const formData = new FormData();

    formData.append(
      'attachment',
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    const apiHost = localStorage.getItem('api_host');

    const endpoint = '/api/requests/approve/batch';

    const obj = {
      link: `${apiHost}${endpoint}`,
      object: {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: formData,
      },
    };

    fetch(obj.link, obj.object)
      .then(async (response) => {    
        if(response.status === 204)  {
          this.setState({ result: true });
          this.props.getData();
        }else{
          const errorData = await response.json(); 
          this.setState({ error: errorData.message || 'Batch approve failed' });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message});
      })
  };

  render() {
    return (
      <>
        <Button
          variant="primary"
          className="csv-upload-btn"
          onClick={this.handleShow}
        >
          Batch Approve
        </Button>

        <Modal
          show={this.state.showModal}
          onHide={this.handleClose}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Batch Approve</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.result && (
              <Alert variant="success">
                Batch approve successful
              </Alert>
            )}
            {this.state.error && (
              <Alert variant="danger">{this.state.error}</Alert>
            )}
            <Form.Group id="exampleFormControlFile1">
                <Form.Label> Choose File </Form.Label>
                <Form.Control type="file" accept=".csv" onChange={this.fileChange} />
             </Form.Group>

            <Button
              variant="primary"
              disabled={this.state.isLoading || !this.state.selectedFile}
              onClick={!this.state.isLoading ? () => this.fileUpload() : null}>
              {this.state.isLoading ? 'Uploading…' : 'Click to upload'}
            </Button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default CSVUploadModal;
